module.exports = __webpack_public_path__ + "img/bnb.f78cb0ac.svg";